import { render, staticRenderFns } from "./NavbarWalletSession.vue?vue&type=template&id=96f9e836"
import script from "./NavbarWalletSession.vue?vue&type=script&lang=ts"
export * from "./NavbarWalletSession.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports